import { Content } from '@3plearning/question-components-library';

export type QuestionSetProps = {
    questName: string
    keypadPreset: number
    questions: Content[]
};

export interface QuestionSetPayload {
    questionSetId: string
    questionSetType: number
    keyboardPreset: number
    totalQuestionCount: number
    questName: string
    learningIntention: Content
    successCriteria: Content
    conceptRefresh: Content
    questionExample: Content
    praiseFeedback: PraiseFeedback[]
    sections: Section[]
}

export interface PraiseFeedback {
    percentage: number
    feedback: string
}

export interface Section {
    sectionName: string
    questionVariantIds: QuestionVariant[]
}

export interface QuestionVariant {
    questionId: string
    questionVariantId: string
    questionContent: QuestionContentPayload
    answerContent: AnswerContentPayload
    sortOrder: number
}

export interface QuestionContentPayload {
    questionVariantId: string
    question: Content
    hint: Content
    measurementTool: Content | null
}

export interface AnswerContentPayload {
    questionVariantId: string
    answers: AnswerValue[][]
    workedSolution: WorkedSolution[]
}

export interface AnswerValue {
    id: number
    content: string | string[]
    validationMethod: string
    options: AnswerOptions
    metaData: unknown | null
}

export interface AnswerOptions {
    ignoreOrder: boolean
    ignoreNestedOrder: boolean
    ignoreLatexSpace: boolean
    unmarked: boolean | null
    disregardCoefficientOne: boolean
    disregardTrailingZeros: boolean
    simplify: boolean
    format: string | null
    argument: number
    decimalSeparator: string | null
    threshold: number
}

export interface WorkedSolution {
    type: string
    content: Content
}

export type NavButtonsProps = {
    navigate: (type: number) => void
};

export type QuestionHeaderProps = {
    questionNumber: number
    totalQuestions: number
    navigate: (type: number) => void
    hintContent: Content
};

export type QuestionFooterProps = {
    onConceptRefreshOpen: () => void
    isConceptRefreshDisabled: boolean
    workedSolutionDocs?: WorkedSolution[]
    setIsWorkedSolutionActivated: (IsWorkedSolutionActivated: boolean) => void
    isWorkedSolutionActivated: boolean
};

export enum Nav {
    forward,
    backward
}
